module.exports = __webpack_public_path__ + "img/product-3-swim.f3976365.png";